// Used in cases where no revenue period is set on the item
// Examples: Contact Sales and Free items
import { RevenueComponent, RevenuePeriod } from '@vendasta/sales-orders';
import { UILineItem } from '@vendasta/store';

export const defaultRevenuePeriodMonthly = RevenuePeriod.MONTHLY;
export const defaultCurrencyCodeUSD = 'USD';

// INVALID_ITEM handles scenarios where order items are no longer available.
// Examples: Has been disabled from the marketplace by the partner or no longer whitelisted to the partner
export const INVALID_ITEM: UILineItem = {
  name: 'Invalid Item',
  iconUrl: null,
  lineItem: null,
};

// defaultRevenue handles scenarios where there's no pricing info on the item (package or product)
// Examples: Contact Sales and Free items
export const defaultRevenue: RevenueComponent = new RevenueComponent({
  value: 0,
  period: defaultRevenuePeriodMonthly,
  isStartingRevenue: false,
});

export const PARTNER_ID = 'PARTNER_ID';
export const MARKET_ID = 'MARKET_ID';

// Used for providing different styles/templates components for desktop and mobile views
export const mobileScreenSizeMax = 600;

// Used for SSC attachments
export const DEMO_SSC_UPLOAD_URL = 'https://sales-orders-demo.apigateway.co/file/upload';
export const PROD_SSC_UPLOAD_URL = 'https://sales-orders-prod.apigateway.co/file/upload';

export const UNIFIED_PAGE_POSTHOG_CATEGORY = 'unified-orders';

export const ChargeFailureCodeMap = {
  incorrect_number: 'PAYMENT_METHOD_SELECTOR.ERROR_INCORRECT_NUMBER',
  card_declined: 'PAYMENT_METHOD_SELECTOR.ERROR_CARD_DECLINED',
  failed_to_add_payment_method: 'PAYMENT_METHOD_SELECTOR.ERROR_ADDING_PAYMENT_METHOD',
  expired_card: 'PAYMENT_DECLINE_REASON.EXPIRED_CARD.DESCRIPTION',
  incorrect_cvc: 'PAYMENT_DECLINE_REASON.INCORRECT_CVC.DESCRIPTION',
  processing_error: 'PAYMENT_DECLINE_REASON.PROCESSING_ERROR.DESCRIPTION',
};

export const ORDER_INJECTION_TOKEN = 'ORDER_INJECTION_TOKEN';
export const ORDER_CONFIG_INJECTION_TOKEN = 'ORDER_CONFIG_INJECTION_TOKEN';
export const ORDER_FORM_OPTIONS_TOKEN = 'ORDER_FORM_OPTIONS_TOKEN';
